import React from 'react';
import { translate } from 'react-i18next';

import {Button, Message, Modal} from 'semantic-ui-react';


const RewardClaimModal = ({t, reward, success, onClose}) => (
        <Modal closeIcon open size="mini" onClose={onClose}>
        <Modal.Header>{success ? t('Congratulations!') : t('Oops!')}</Modal.Header>
        <Modal.Content>
            {success ?
                <Message positive>
                    {t('success_message', {title:reward.title})}
                    <br /> 
                    {t('success_message2')}
                </Message>
              : 
                <Message negative>
                    {t('failure_message', {title:reward.title})}
                    <br />
                    {t('please_try_again')}
                </Message>
            }
            <Button type="button" fluid color="teal" onClick={onClose}>OK</Button>
        </Modal.Content>
      </Modal>
  );

export default translate('rewards')(RewardClaimModal);



// WEBPACK FOOTER //
// ./src/modules/rewards/RewardClaimModal.js